import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";

// Initialize i18next synchronously with default English translations
// Additional translations will be loaded dynamically via updateLocalization
i18next.use(LanguageDetector).init({
	interpolation: { escapeValue: false },
	fallbackLng: "en",
	defaultNS: "common",
	detection: {
		order: ["sessionStorage", "navigator"],
		caches: ["sessionStorage"],
	},
	resources: {
		en: {
			common: en,
		},
	},
});

export default i18next;
